module.exports = __webpack_public_path__ + "static/img/copybtn.6e363c17.svg";